import {
  getAuthencatedNotificationsIndexResource,
  subscribeAuthenticatedRegisterTokenResource,
  getAuthenticatedNotificationsTotalUnreadResource,
  removeAuthenticatedTokenByDeviceIdResource,
  getAuthenticatedProductsIndexResource,
  removeAuthenticateDeviceTokenResource,
  updateAuthenticatedNotificationInterectedAt,
  removeAuthencatedNotiticationsByIdResource
} from './resources'

import { DEFAULT_AUTH_HEADER, DEFAULT_AUTH_SCHEME } from './client'

export const DEFAULT_PLATFORM = 1 // 1 = web

class APIClient {
  constructor(
    apiHost,
    authToken,
    authHeader = DEFAULT_AUTH_HEADER,
    authScheme = DEFAULT_AUTH_SCHEME
  ) {
    this.apiHost = apiHost
    this.authToken = authToken
    this.authHeader = authHeader
    this.authScheme = authScheme

    this.authRequestParams = [
      this.apiHost,
      this.authToken,
      this.authHeader,
      this.authScheme
    ]
  }

  getNotifications(productId = null, pageIndex = 1, pageSize = 5) {
    const requestData = {
      params: {
        productsId: productId,
        pageSize,
        pageIndex
      }
    }

    const requestConfig = this.getRequestParams(requestData)

    return getAuthencatedNotificationsIndexResource(...requestConfig)
  }

  getUnreadNotificationsCount(params = {}) {
    const requestConfig = this.getRequestParams(params)

    return getAuthenticatedNotificationsTotalUnreadResource(...requestConfig)
  }

  getProducts(params = {}) {
    const requestConfig = this.getRequestParams(params)

    return getAuthenticatedProductsIndexResource(...requestConfig)
  }

  subscribeToken(
    token,
    productIdentifier,
    deviceId = null,
    platform = DEFAULT_PLATFORM,
    params = {}
  ) {
    const { data = {} } = params

    const requestData = {
      ...params,
      data: {
        ...data,
        platform,
        value: token,
        productIdentifier,
        deviceId
      }
    }

    const requestConfig = this.getRequestParams(requestData)

    return subscribeAuthenticatedRegisterTokenResource(...requestConfig)
  }

  deleteToken(token, params = {}) {
    const requestData = {
      ...params,
      token
    }

    const requestConfig = this.getRequestParams(requestData)

    return removeAuthenticateDeviceTokenResource(...requestConfig)
  }

  deleteTokenByDeviceId(deviceId, params = {}) {
    const requestData = {
      ...params,
      deviceId
    }

    const requestConfig = this.getRequestParams(requestData)

    return removeAuthenticatedTokenByDeviceIdResource(...requestConfig)
  }

  updateInterected(notificationId, actionId, params = {}) {
    const requestData = {
      ...params,
      notificationId,
      actionId
    }

    const requestConfig = this.getRequestParams(requestData)

    return updateAuthenticatedNotificationInterectedAt(...requestConfig)
  }

  getRequestParams(params = {}) {
    return [...this.authRequestParams, params]
  }

  removeNegotiationById(params = {}) {
    const requestConfig = this.getRequestParams(params)

    console.log('requestConfig', requestConfig)

    return removeAuthencatedNotiticationsByIdResource(...requestConfig)
  }
}

export default APIClient
